import InstrumentIcon from "../instrument-icon";
import moment from "moment/moment";
import Big from "big.js";
import SvgIcon from "../svg-icon";
import {useTranslation} from "react-i18next";

const GeneralStatsItem = props => {

    const {t} = useTranslation()

    const {
        stat,
        handleBetDetail,
        handleUserDetail
    } = props
    return (
        <tr key={stat?.timestamp}>
            <td>
                <div className="xtable__text">
                    {/*<img loading="lazy"className={'sml-img'} src={stat?.game?.image} alt="--"/>*/}
                    <a onClick={e => handleBetDetail(stat)}>{stat?.game_name || stat?.game?.name}</a>
                </div>
            </td>
            <td>

                <div onClick={e => handleUserDetail(stat)} className="xtable__text text-white">
                    {/*{stat?.customer?.username}*/}

                    {stat?.customer?.is_public ? stat?.customer?.username :

                        <span className="d-flex align-items-center justify-content-center gap-1">
                        <SvgIcon id={'hidden'}/>
                            {t('general.hidden')}
                    </span>
                    }
                </div>
            </td>
            <td>
                <div className="xtable__text">
                    <small>
                        {moment.unix(stat?.timestamp || 0).format('LL')}
                    </small>
                </div>
            </td>
            <td>
                <div className="xtable__coin gap-1">
                    {Big(stat?.wallet_amount || stat?.amount || 0).toFixed(['TRY', 'USD', 'USDT', 'EUR'].includes(stat?.wallet_currency || stat?.currency) ? 2 : 5)}
                    <InstrumentIcon code={stat?.wallet_currency || stat?.currency}/>
                </div>
            </td>
            <td>
                <div className="xtable__text text-white">x{stat?.multiplier}</div>
            </td>
            <td>
                <div className="xtable__coin xtable__coin--green gap-1">
                    {Big(stat?.wallet_income || stat?.income || 0).toFixed(['TRY', 'USD', 'USDT', 'EUR'].includes(stat?.wallet_currency || stat?.currency) ? 2 : 5)}
                    <InstrumentIcon code={stat?.wallet_currency}/>
                </div>
            </td>
        </tr>
    )

}

export default GeneralStatsItem
